import React from "react";
import CurrencyIcon from "../ui/CurrencyIcon";
import { GEMS_ENABLED, formatCurrencyAmount, isAmountHidden, resolveDisplayCurrency } from "../../common/currencies";

const StatsCard = ({ label, value, currencyCode }) => {
  return (
    <div className="border border-neutral-800 rounded-app p-2 sm:p-4 flex flex-col items-center justify-center shadow-sm"
      style={{
        background: 'linear-gradient(180deg, #252525 0%, #1E1D1D 73.56%, #1E1D1D 100%)',
        borderTopWidth: '0.5px',
        borderTopStyle: 'solid',
        borderImageSource: 'linear-gradient(90deg, #121212 0%, #666666 53.85%, #121212 100%)',
        borderImageSlice: '1 0 0 0',
      }}
    >
      <div className={`text-[22px] sm:text-2xl font-extrabold mb-0.5 text-white font-saira flex items-center justify-center gap-1`}>
        {currencyCode && <CurrencyIcon code={currencyCode} className="h-5 w-5" symbolClassName="text-[var(--brand)]" />}
        {value}
      </div>
      <div className="text-[9px] sm:text-[11px] text-[var(--text-dark)] font-bold uppercase tracking-wider text-center leading-tight">
        {label}
      </div>
    </div>
  );
};

const StatsOverview = ({ stats }) => {
  const cashCurrency = resolveDisplayCurrency(stats?.totalWinningAmount?.usd?.currencyCode || "USD");
  const totalWinnings = formatCurrencyAmount(stats?.totalWinningAmount?.usd?.value, cashCurrency);
  const gemCurrency = resolveDisplayCurrency(stats?.totalWinningAmount?.gems?.currencyCode || "GEMS");
  const hideGems =
    !GEMS_ENABLED || isAmountHidden(stats?.totalWinningAmount?.gems?.currencyCode || "GEMS");
  const totalGemWinnings = formatCurrencyAmount(stats?.totalWinningAmount?.gems?.value, gemCurrency);
  return (
    <div className={`grid gap-2 sm:gap-4 mb-8 ${hideGems ? "grid-cols-3" : "grid-cols-2 sm:grid-cols-4"}`}>
      <StatsCard label="Total Plays" value={stats?.totalGamesPlayed || 0} />
      <StatsCard label="Top Score" value={stats?.topScore || 0} />
      <StatsCard label="Total Winnings" value={totalWinnings} currencyCode={cashCurrency} />
      {!hideGems && (
        <StatsCard label="Total Winnings" value={totalGemWinnings} currencyCode={gemCurrency} />
      )}
    </div>
  );
};

export default StatsOverview;
